
<template>
  <g class="not-copy" @dblclick="openEdit" @contextmenu.prevent="openContextMenu">
    <!-- 選択時の枠 -->
    <rect fill="transparent" :stroke="cursorColor" stroke-width="3" :stroke-dasharray="cursorDasfArray" :stroke-dashoffset="cursorDasfOffset" :x="scenario.beforenodeX - 5" :y="scenario.beforenodeY - 5" :width="cursorBoxX + 10" :height="cursorBoxY * (scenario.select.length + 1) + 20" :rx="rxSize" v-if="(scenario.status === 0 && (isMoveScenario))"></rect>
    <rect fill="transparent" :stroke="cursorColor" stroke-width="3" :stroke-dasharray="cursorDasfArray" :stroke-dashoffset="cursorDasfOffset" :x="scenario.beforenodeX - 5" :y="scenario.beforenodeY - 5" :width="cursorBoxX - 45" :height="cursorBoxY + 10" :rx="rxSize" v-if="((scenario.status === 1 || scenario.status === 8)&& (isMoveScenario))"></rect>
    <rect fill="transparent" :stroke="cursorColor" stroke-width="3" :stroke-dasharray="cursorDasfArray" :stroke-dashoffset="cursorDasfOffset" :x="scenario.beforenodeX - 5" :y="scenario.beforenodeY - 5" :width="cursorBoxX + 10" :height="cursorBoxY * (scenario.select.length) + 10" :rx="rxSize" v-if="((scenario.status === 2 || scenario.status === 4 || scenario.status === 6 || scenario.status === 7) && (isMoveScenario))"></rect>
    <!-- Node -->
    <rect :fill="bgColorBlue" :x="scenario.beforenodeX" :y="scenario.beforenodeY" :width="nodeSize" :height="nodeSize" :rx="rxSize" @mouseover="saveConnectNode" v-if="!scenario.start_flg && scenario.status!=22"></rect>
    <circle stroke="#CCC" :fill="bgColorLightBlue" :cx="scenario.beforenodeX + 21" :cy="scenario.beforenodeY + 22.5" :r="startNodeSize" @mouseover="saveConnectNode" v-if="scenario.start_flg && scenario.status!=22"></circle>
    <text fill="black" font-size="25" v-if="scenario.start_flg" :x="scenario.beforenodeX + 15" :y="scenario.beforenodeY + 30.5">S</text>
    <!-- Message -->
    <rect :fill="bgColorBlue"  :x="Number(scenario.beforenodeX) + 55" :y="scenario.beforenodeY" :width="messageBoxX" :height="messageBoxY" :rx="rxSize" @mousedown="moveScenario"></rect>
    <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="Number(scenario.beforenodeY) + 5" :width="messageX" :height="messageY" :rx="rxSize" @mousedown="moveScenario"></rect>
    <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30" @mousedown="moveScenario" v-if="scenario.status!==3&&scenario.status!==6">{{scenario.is_confirm}}{{subMessage(scenario.mainmessage, 13)}}</text>
    <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30" @mousedown="moveScenario" v-if="scenario.status===3">{{subMessage(scenario.mainmessage, 13)}}へ</text>
    <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30" @mousedown="moveScenario" v-if="scenario.status===6">[入力]{{subMessage(scenario.mainmessage, 15)}}</text>
    <!-- Select -->
    <g v-if="scenario.status===0">
      <rect :fill="bgColorBlue"  :x="Number(scenario.beforenodeX) + 55"  :y="Number(scenario.beforenodeY) + 55" :width="selectBoxX" :height="Number(selectBoxY * (scenario.select.length))" :rx="rxSize" @mousedown="moveScenario"></rect>
      <g v-for="(s, i) in scenario.select" :key="i">
        <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60"  :y="Number(scenario.beforenodeY) + (i * 45) + 60" :width="messageX" :height="messageY" :rx="rxSize" @mousedown="moveScenario"></rect>
        <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65"  :y="Number(scenario.beforenodeY) + (i * 45) + 85" @mousedown="moveScenario">{{subMessage(s.message, 13)}}</text>
        <rect :fill="makeColorNodeBox(i)"  :x="Number(scenario.beforenodeX) + 265" :y="Number(scenario.beforenodeY) + (i * 45) + 60" :width="Number(nodeSize - 5)" :height="Number(nodeSize - 5)" :rx="rxSize" @mousedown="lineNode(i, $event)"></rect>
      </g>
    </g>
    <!-- Only Message Next Node -->
    <g v-else-if="scenario.status===1 || scenario.status===2 || scenario.status===4 || scenario.status===6 || scenario.status===7 || scenario.status===8">
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 265" :y="scenario.beforenodeY" :width="nodeSize" :height="nodeSize" :rx="rxSize" @mousedown="lineNode(0, $event)"></rect>
    </g>
    <!-- Image -->
    <g v-else-if="scenario.status===5" >
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 55" :y="scenario.beforenodeY + 55" :width="selectBoxX" :height="selectBoxY * 3" :rx="rxSize" @mousedown="moveScenario"></rect>
      <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="scenario.beforenodeY + 60" :width="selectBoxX - 10" :height="selectBoxY * 3 - 10" :rx="rxSize" @mousedown="moveScenario"></rect>
      <image :x="Number(scenario.beforenodeX) + 85" :y="scenario.beforenodeY + 65" :width="nodeSize * 3" :height="nodeSize * 2.5" :xlink:href="makeImageScenario(scenario.image)" @mousedown="moveScenario"/>
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 265" :y="scenario.beforenodeY" :width="nodeSize" :height="nodeSize" :rx="rxSize" @mousedown="lineNode(0, $event)"></rect>
    </g>
    <path :d="path" fill="none" :stroke="strokeFill" :opacity="strokeOpacity" :stroke-width="strokeWidth" stroke-linecap="round" v-if="path !== '' && isLineNode"/>
  </g>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from '@/functions/hex2rgb'
export default {
  name: 'ScenarioGroupDemo',
  componentName: 'ScenarioGroupDemo',
  props: ['scenario', 'ratio', 'dx', 'dy'],
  computed: {
    ...mapState('chatbot', ['isConnecting', 'scenarioNodeData', 'nextNode']),
    ...mapState('auth', ['botstatus', 'user'])
  },
  data () {
    return {
      isMoveScenario: false,
      isLineNode: false,
      beforeMouseX: null,
      beforeMouseY: null,
      bgColorWhite: '#f8f8f8',
      bgColorLightBlue: '#ccfff2',
      bgColorMidBlue: '#65ffd8',
      bgColorBlue: '#00cb98',
      bgColorGray: '#c0c0c0',
      bgColorYellowList: ['#00cb98', '#CCFFCC'],
      startColorSetting: '#00cb98',
      bgColorFont: '#000',
      nodeSize: 45,
      startNodeSize: 25,
      rxSize: 5,
      fontSize: '12px',
      cursorBoxX: 310,
      cursorBoxY: 45,
      cursorColor: '#99CCFF',
      cursorDasfOffset: 0,
      cursorDasfArray: 5,
      messageBoxX: 200,
      messageBoxY: 45,
      messageX: 190,
      messageY: 35,
      selectBoxX: 200,
      selectBoxY: 45,
      selectX: 190,
      selectY: 35,
      moveLineX: 0,
      moveLineY: 0,
      startLineX: 0,
      startLineY: 0,
      path: '',
      strokeWidth: '3',
      strokeFill: '#000',
      strokeOpacity: 0.5,
      isMouseout: false
    }
  },
  mounted () {
    console.debug('*** Start *** mounted')
    console.log('MOUNT LISTENER ON')
    document.addEventListener('mouseup', this.mouseUp)
    document.addEventListener('mousemove', this.mouseMove)
    console.debug('*** End *** mounted')
  },
  beforeDestroy () {
    console.debug('*** Start *** beforeDestroy')
    console.log('MOUNT LISTENER OFF')
    document.removeEventListener('mouseup', this.mouseUp)
    document.removeEventListener('mousemove', this.mouseMove)
    console.debug('*** End *** beforeDestroy')
  },
  methods: {
    mouseOut (event) {
      console.debug('*** Start *** mouseOut')
      console.debug('event: ' + JSON.stringify(event))
      console.log('MOUSEOUT')
      this.isMouseout = true
      console.debug('*** End *** mouseOut')
    },
    makeColorNodeBox (i) {
      console.debug('*** Start *** mouseOut')
      console.debug('i: ' + JSON.stringify(i))
      if (this.isLineNode && Object.keys(this.scenarioNodeData).length === 1) {
        console.info('scenarioNodeData length is 1')
        if (this.scenarioNodeData[0].select[this.nextNode].next_node === this.scenario.select[i].next_node && this.nextNode === i) return '#f00'
        else return this.bgColorBlue
      }
      else return this.bgColorBlue
    },
    makeImageScenario (img) {
      console.debug('*** Start *** makeImageScenario')
      console.debug('img: ' + JSON.stringify(img))
      if (img != '') return img
      else return require('@/assets/template/no_image.svg')
    },
    makeStart () {
      console.debug('*** Start *** makeStart')
      return 'M' + this.scenario.beforenodeX + ',' + this.scenario.beforenodeY + this.startFig
    },
    startColor () {
      console.debug('*** Start *** startColor')
      if (this.scenario.start_flg) return this.bgColorYellow
      else return this.bgColorBlue
    },
    curve (node) {
      console.debug('*** Start *** curve')
      console.debug('node: ' + JSON.stringify(node))
      const qx1 = (node.start.x + node.end.x) / 2
      const qy1 = (node.start.y + node.end.y) / 2
      const qx2 = ((node.start.x + node.end.x) / 2 + node.start.x) / 2
      const amplitude = (node.end.y - node.start.y) / 4
      const qy2 = (node.start.y + node.end.y) / 2 + amplitude
      this.path = 'M' + node.start.x + ',' + node.start.y + ' Q' + qx2 + ',' + qy2 + ' ' + qx1 + ',' + qy1 + ' T' + node.end.x + ',' + node.end.y
      console.debug('*** End *** curve')
    },
    subMessage (m, num) {
      console.debug('*** Start *** subMessage')
      console.debug('m: ' + JSON.stringify(m))
      console.debug('num: ' + JSON.stringify(num))
      // 応募フォーム以外
      // alert(m)
      if (m.indexOf('[calendar]') !== -1) {
        console.info('Automatic schedule adjustment')
        return '日程自動調整'
      } else if (m.indexOf('[cv][/cv]') !== -1) {
        console.info('Application Form')
        return '応募フォーム'
      } else if (m.indexOf('[fileupload][/fileupload]') !== -1) {
        console.info('file upload')
        return 'ファイルアップロード'
      } else if (m.indexOf('[image][/image]') !== -1) {
        console.info('Image display')
        return '画像表示'
      } else if (m.indexOf('[input]') !== -1 && m.indexOf('[/input]') !== -1) {
        console.info('input is not -1')
        var w = m.replace('[input]', '').replace('[/input]', '')
        if (w[0] == null) return w[0]
        else return w[0] < num ? w : w[0].substring(0, num - 3) + '...'
      }else if (m.indexOf('[resume][/resume]') !== -1) {
        console.info('Resume form')
        return '履歴書フォーム'
      } else {
        console.info('else')
        m = m.replace('[memo]', '').replace('[/memo]', '')
        if (m.indexOf('\n') === -1) return m.length < num ? m : m.substring(0, num - 3) + '...'
        else {
          var w = m.split('\n')
          return w[0] < num ? m : w[0].substring(0, num - 3) + '...'
        }
      }
      console.debug('*** End *** subMessage')
    },
    moveScenario (event) {
      console.debug('*** Start *** moveScenario')
      console.debug('event: ' + JSON.stringify(event))
      event.preventDefault()
      this.isMoveScenario = true
      this.$store.dispatch('chatbot/setPathScenario', this.scenario)
      console.debug('*** End *** moveScenario')
    },
    saveConnectNode (event) {
      console.debug('*** Start *** saveConnectNode')
      console.debug('event: ' + JSON.stringify(event))
      // console.log('PUTPUT Connect MOUSEOVER: ' + this.isConnecting + ', ' + this.isLineNode + ', ' + JSON.stringify(this.scenario))
      if (this.isConnecting&&!this.isLineNode) this.$store.dispatch('chatbot/changeIsConnecting', {flg: true, scenario: this.scenario})
      event.preventDefault()
      console.debug('*** End *** saveConnectNode')
    },
    lineNode (i, event) {
      console.debug('*** Start *** lineNode')
      console.debug('i: ' + JSON.stringify(i))
      console.debug('event: ' + JSON.stringify(event))
      // console.log('PUTPUT LINENODE: ' + event.offsetX + ',' + event.offsetY)
      // console.log('PUTPUT LINENODE lineNode: ' + i + ',' + event.offsetY)
      this.startLineX = event.offsetX * this.ratio + this.dx
      this.startLineY = event.offsetY * this.ratio + this.dy
      this.moveLineX = event.offsetX * this.ratio + this.dx
      this.moveLineY = event.offsetY * this.ratio + this.dy
      this.isLineNode = true
      this.$store.dispatch('chatbot/saveNextNode', i)
      this.$store.dispatch('chatbot/changeIsConnecting', {flg: true, scenario: this.scenario})
      event.preventDefault()
      console.debug('*** End *** lineNode')
    },
    mouseUp (event) {
      console.debug('*** Start *** mouseUp')
      console.debug('event: ' + JSON.stringify(event))
      if (Object.keys(this.scenarioNodeData).length > 1) {
        console.info('SAVE NODE Connect status MOUSEOVER: ' + Object.keys(this.scenarioNodeData).length + ',' + JSON.stringify(this.scenarioNodeData))
        var s = this.scenarioNodeData[0]
        s.select[this.nextNode].next_node = this.scenarioNodeData[1].beforenode
        console.info('SAVE NODE Connect status MOUSEOVER s: ' + JSON.stringify(s))
        this.$store.dispatch('chatbot/setScenarioDemo', s)
      }
      this.$store.dispatch('chatbot/changeIsConnecting', {flg: false, scenario: this.scenario})
      this.$store.dispatch('chatbot/setPathScenario', null)
      this.isMoveScenario = false
      this.isLineNode = false
      this.beforeMouseX = null
      this.beforeMouseY = null
      this.path = ''
      this.isMouseout = false
      event.preventDefault()
      console.debug('*** End *** mouseUp')
    },
    mouseMove (event) {
      if (!this.isMoveScenario && !this.isLineNode) return
      var mouseX = event.offsetX * this.ratio + this.dx
      var mouseY = event.offsetY * this.ratio + this.dy
      var dx = 0
      var dy = 0
      if (this.beforeMouseX && this.beforeMouseY) {
        dx = mouseX - this.beforeMouseX
        dy = mouseY - this.beforeMouseY
      }
      this.beforeMouseX = mouseX
      this.beforeMouseY = mouseY
      var tempX = 0
      var tempY = 0
      // 動かす場合
      if (this.isMoveScenario) {
        tempX = dx + Number(this.scenario.beforenodeX)
        tempY = dy + Number(this.scenario.beforenodeY)
        if (tempX > 0 && !this.isMouseout) this.scenario.beforenodeX = tempX
        if (tempY > 0 && !this.isMouseout) this.scenario.beforenodeY = tempY
      }
      // 線を引く場合
      if (this.isLineNode) {
        tempX = this.moveLineX
        tempY = this.moveLineY
        tempX += dx
        tempY += dy
        if (tempX > 0) this.moveLineX = tempX
        if (tempY > 0) this.moveLineY = tempY
        // console.log('testtest2 curve: ' + this.startLineX + ', ' + this.startLineY + ', ' + this.moveLineX + ', ' + this.moveLineY + ', ' + dx + ', ' + dy)
        this.curve({
          start: {
            x: this.startLineX,
            y: this.startLineY
          },
          end: {
            x: this.moveLineX,
            y: this.moveLineY
          }
        })
      }
      event.preventDefault()
      console.debug('*** End *** mouseMove')
    },
    openEdit () {
      console.debug('*** Start *** openEdit')
      this.$store.dispatch('chatbot/selectScenario', this.scenario)
      this.$store.dispatch('chatbot/changeModalEditScenario')
      console.debug('*** End *** openEdit')
    },
    openContextMenu (event) {
      console.debug('*** Start *** openContextMenu')
      console.debug('event: ' + JSON.stringify(event))
      // if (this.isLineNode || this.isMoveScenario) {
        var menu = document.getElementById("context-menu")
        if(!this.contextMenuWidth || !this.contextMenuHeight) {
          console.info('!this.contextMenuWidth || !this.contextMenuHeight')
          menu.style.visibility = 'hidden'
          menu.style.display = 'block'
          this.contextMenuWidth = menu.offsetWidth
          this.contextMenuHeight = menu.offsetHeight
          menu.removeAttribute('style')
        }
        if((this.contextMenuWidth + event.pageX) >= window.innerWidth) {
          console.info('(this.contextMenuWidth + event.pageX) >= window.innerWidth')
          menu.style.left = (event.pageX - this.contextMenuWidth) + 'px'
        } else {
          console.info('else (pageX)')
          menu.style.left = event.pageX + 'px'
        }
        if((this.contextMenuHeight + event.pageY) >= window.innerHeight) {
          console.info('(this.contextMenuHeight + event.pageY) >= window.innerHeight')
          menu.style.top = (event.pageY - this.contextMenuHeight) + 'px'
        } else {
          console.info('else (pageY)')
          menu.style.top = event.pageY + 'px'
        }
        menu.classList.add('active')
        this.$store.dispatch('chatbot/selectScenario', this.scenario)
      // }
      console.debug('*** End *** openEdit')
    },
    closeContextMenu () {
      console.debug('*** Start *** closeContextMenu')
      document.getElementById('context-menu').classList.remove('active')
      console.debug('*** End *** closeContextMenu')
    }
  }
}
</script>

<style scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Top/ScenarioGroupDemo.vue